function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.00781 12.7656L7.22656 12.5469C7.28125 12.4922 7.30859 12.4193 7.30859 12.3281C7.30859 12.237 7.28125 12.1549 7.22656 12.082L1.86719 6.75L7.22656 1.41797C7.28125 1.34505 7.30859 1.26302 7.30859 1.17188C7.30859 1.08073 7.28125 1.00781 7.22656 0.953125L7.00781 0.734375C6.95312 0.679688 6.88021 0.652344 6.78906 0.652344C6.69792 0.652344 6.625 0.679688 6.57031 0.734375L0.773438 6.53125C0.71875 6.58594 0.691406 6.65885 0.691406 6.75C0.691406 6.84115 0.71875 6.91406 0.773438 6.96875L6.57031 12.7656C6.625 12.8203 6.69792 12.8477 6.78906 12.8477C6.88021 12.8477 6.95312 12.8203 7.00781 12.7656Z",
  fill: "currentColor"
});

var SvgChevronLeft = function SvgChevronLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgChevronLeft, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chevron-left.fb0cc039.svg";
export { ForwardRef as ReactComponent };